// extracted by mini-css-extract-plugin
module.exports = {"root":"status-badge_root__V_cxl","variant-open":"status-badge_variant-open__6xnFg","variant-close":"status-badge_variant-close__3oste"};